import DashboardAdmin from "./dashboard_admin";
import { LayoutAdminCafe } from "../../../layout/layout_cafe";

export function AdminDashboard() {
  return (
    <>
      <LayoutAdminCafe>
        <DashboardAdmin />
      </LayoutAdminCafe>
    </>
  );
}